import { render, staticRenderFns } from "./cat-complete-approve-opinion.vue?vue&type=template&id=64e1a5f8&scoped=true&"
import script from "./cat-complete-approve-opinion.vue?vue&type=script&lang=js&"
export * from "./cat-complete-approve-opinion.vue?vue&type=script&lang=js&"
import style0 from "./cat-complete-approve-opinion.vue?vue&type=style&index=0&id=64e1a5f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e1a5f8",
  null
  
)

export default component.exports